import YesIcon from 'assets/images/yes-icon.svg';
import freebieIcon from 'assets/images/freebie-icon.svg';
import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';

import Theme from 'theme';
import CustomTheme from 'customTheme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
  // SYNC-1090: parent origins allowed to receive booking events from the
  // embedded scheduler. Comma-separated exact origins; unset => feature off.
  REACT_APP_PARENT_EVENT_ORIGINS: parentEventOrigins,
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logoRedirectLink: 'https://urbndental.com/',
  logo: 'https://subscribili.gumlet.io/patient-portal-assets/urbn-logo_r7sqgl.png',
  cptCodesIcon: YesIcon,
  portalName: 'urbndental',
  // Industry drives the Strapi FAQ template (SAP-7671). Omit to default to 'dental'.
  // Valid: dental | primary-care | chiropractic | dermatology | urgent-care | veterinary
  industry: 'dental',
  tokenName: 'urbndentalSubscriberToken',
  globalClass: 'urbndental-container',
  clientHeader,
  enableHeroButton: true,
  enableBookAppointment: true,
  pricingType: 'standard-pricing',
  heroLocaleColor: 'secondary',
  skipChoosePlan: true,
  headerProps: {
    enable: false,
  },
  homeTemplateProps: {
    heroSection: {
      variant: 1,
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      secondaryButtonProps: {
        to: '/login',
        color: 'primary',
      },
      heroImage: '/images/home-images/home-banner-img.webp',
      verticalAlignImage: 'bottom',
    },
    benefitsSection: {
      enable: false,
    },
    subscriptionSection: {
      tabVariant: 2,
      loaderColor: 'secondary',
      cardVariant: 1,
      carouselResponsiveItems: {
        desktop: 3,
      },
      planCardProps: {
        buttonProps: {
          customSpace: 12,
        },
        enableDisclosureText: true,
      },
    },
    freebieSection: {
      enable: true,
      listIcon: freebieIcon,
      alternateImg: '/images/freebieSmall.webp',
      heroImage: '/images/freebie.webp',
    },
    howItWorksSection: {
      variant: 3,
      primaryButtonProps: {
        variant: 'outlined',
        color: 'secondary',
      },
    },
    savingsDetailsSection: {
      mobileImage: '/images/savingsTable.webp',
      deskTopImage: '/images/savingsTableDesktop.webp',
      enable: true,
    },
    testimonialSection: {
      variant: 2,
      centerMode: true,
      avatarStyle: 'top',
      subtitleVariant: 'body1',
      sectionClass: 'section-container',
      messageType: 'h6',
      carouselResponsiveItem: {
        superLarge: 1,
        large: 1,
      },
    },
    textOnlyHowItWorks: {
      enable: true,
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  checkoutSection: {},
  findProviderSection: {
    variant: 2,
    locationWrapper: 6,
    mapWrapper: 6,
    heroProps: {
      secondaryButtonProps: {
        variant: 'outlined',
        color: 'primary',
      },
    },
    iconProps: {
      url: 'https://subscribili.gumlet.io/patient-portal-assets/location-marker_feklye.png',
    },
  },
  choosePlanSection: {
    sectionSubtitle: '',
    placeLogoContainerAtTop: true,
    locationLogo:
      'https://subscribili.gumlet.io/patient-portal-assets/location-marker_feklye.png',
    cardVariant: 2,
    tabVariant: 2,
    planCardProps: {
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'contained',
        highlightedVariant: 'outlined',
      },
      enableDisclosureText: true,
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: true,
  },
  bookAppointmentV2: {
    theme: CustomTheme,
    rightImage: '/images/appointment/right-image.webp',
    skipPatientTypeSelection: true,
    flowV2: true,
    parentEventOrigins,
    enableDiscoverDiscount: true,
    enableVerifyInsurance: false,
    thankYouPage: {
      haveConfirmationTextWithPhoneNumber: true,
    },
  },
  savingsSummary: {
    enableFooterbar: true,
    contactSection: 'contactDetails',
    heroProps: {
      secondaryButtonProps: {
        variant: 'outlined',
        color: 'primary',
      },
    },
    moreSavingsButtonProps: {
      variant: 'contained',
      color: 'primary',
    },
  },
  faqSection: {
    heroProps: {
      secondaryButtonProps: {
        variant: 'outlined',
        color: 'primary',
      },
    },
  },
  dashboardProps: {
    showBenefitsUsage: true,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  bookAppointment: {},
  footer: {
    enable: false,
  },
  loginPage: {
    bannerImage: './images/login.webp',
  },
  theme: Theme,
  patientForms: {
    enabled: true,
    verifybackgroundImage: '/images/payment-right-banner.webp',
    theme: CustomTheme,
  },
  surveyForms: {
    enabled: true,
    theme: CustomTheme,
  },
};

export default config;
